import { SAVE_AUTH_INFO } from "features/yard360/store/authInfo/types";

export const saveAuthInfo = (authInfo) => {
  return {
    type: SAVE_AUTH_INFO,
    payload: authInfo,
  };
};
